import { render, staticRenderFns } from "./ReservationPurposeColumnStaffArea.vue?vue&type=template&id=3bcf7658&scoped=true&"
import script from "./ReservationPurposeColumnStaffArea.vue?vue&type=script&lang=js&"
export * from "./ReservationPurposeColumnStaffArea.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPurposeColumnStaffArea.vue?vue&type=style&index=0&id=3bcf7658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcf7658",
  null
  
)

export default component.exports